import {SearchItem} from "./search/search-table.dto.res";
import {DocumentContactDto} from "./document-contact.dto";
import {SubInvoiceDto} from "./sub-invoice.dto";

export class DeliveryNoteDto implements SubInvoiceDto, SearchItem {

  public readonly id!: string;
  public readonly number!: string;
  public readonly mediaId!: string;
  public readonly filename!: string;
  public readonly created!: Date;

  // Transient: is set for price calc for a letter (in media-viewer)
  public contact: DocumentContactDto | undefined;

  constructor(init?: Partial<DeliveryNoteDto> | undefined) {
    Object.assign(this, init);
    if (init?.created) {
      this.created = new Date(init.created);
    }
  }

  isDeliveryNote(): boolean {
    return true;
  }

  isProformaInvoice(): boolean {
    return false;
  }

  isEditable(): boolean {
    return false;
  }

  clone(): SubInvoiceDto {
    return new DeliveryNoteDto(this);
  }
}
